export const DISPATHPLATFORM = 'DISPATHPLATFORM' // 平台数据列表
export const DISPATHPLATFORMADD = 'DISPATHPLATFORMADD' // 新增平台数据
export const DISPATHPLATFORMUPDATE = 'DISPATHPLATFORMUPDATE' // 编辑平台数据
export const DISPATHPLATFORMDELETE = 'DISPATHPLATFORMDELETE' // 删除平台数据
export const DISPATHPLATFORMALL = 'DISPATHPLATFORMALL' // 平台数据下拉框



// WEBPACK FOOTER //
// ./src/store/dispatchPlatform/types.js